import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlockList from './content_block_list';
import BlockDetail from './content_block_detail';

class Block extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <BlockList/>;
    }else{
      if(params.id===undefined){
        view = <BlockDetail/>;
      }else{
        view = <BlockDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Block.contextTypes = {
  router: PropTypes.object
};

export default Block;
